import { useEffect, useState } from 'react';

export default function usePickLock(window) {
  const [now, setNow] = useState(Date.now);
  const deadline = window?.deadline ? new Date(window.deadline).getTime() : null;
  useEffect(() => {
    if (!deadline || window?.locked) return;
    const remaining = deadline - Date.now();
    if (remaining <= 0) { if (now < deadline) setNow(Date.now()); return; }
    const timer = setTimeout(() => setNow(Date.now()), Math.min(remaining + 10, 60000));
    return () => clearTimeout(timer);
  }, [deadline, window?.locked, now]);
  return !!window?.locked || (deadline != null && now >= deadline);
}
